import React from 'react';
import { connect, ResolveThunks } from 'react-redux';

import { JackGirderConnection } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { RootState } from '../../../../store';
import { finishInsertingJackGirderConnection } from '../../../../store/actions/insertActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getCarriedComponentDesignCandidatesForActiveComponentDesign } from '../../../../store/selectors/getJackGirderConnections';
import {
  carriedComponentConnectionIsValid,
  CarriedComponentConnectionProperties,
  getDefaultCarriedComponentConnection,
} from '../properties/CarriedComponentConnectionProperties';
import InsertionPanelContainer from './InsertionPanelContainer';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

interface State {
  readonly carriedComponentConnection: JackGirderConnection;
}

class CarriedComponentConnectionInsertion extends React.Component<Props, State> {
  readonly state: State = {
    carriedComponentConnection: getDefaultCarriedComponentConnection(this.props.carryingComponentDesign!.guid),
  };

  render() {
    const { carriedComponentDesignCandidates, carryingComponentDesign, insertionInfo } = this.props;
    if (insertionInfo === null || !carryingComponentDesign) return null;

    return (
      <InsertionPanelContainer
        disabled={
          !carriedComponentConnectionIsValid(
            this.state.carriedComponentConnection,
            carryingComponentDesign,
            carriedComponentDesignCandidates,
          )
        }
        onInsert={() => this.props.finishInsertingJackGirderConnection(this.state.carriedComponentConnection)}
      >
        <PropertiesPanel title="Add Carried Component(s)">
          <CarriedComponentConnectionProperties
            layout="two-columns"
            carriedComponentConnection={this.state.carriedComponentConnection}
            carryingComponentDesign={carryingComponentDesign}
            carriedComponentDesignCandidates={carriedComponentDesignCandidates}
            onChange={(carriedComponentConnectionAndConnectors) =>
              void this.setState(carriedComponentConnectionAndConnectors)
            }
            canSubmitWhenInvalid
          />
        </PropertiesPanel>
      </InsertionPanelContainer>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  const { insertingObjectInfo } = state.application;
  const insertionInfo =
    insertingObjectInfo && insertingObjectInfo.type === 'jackGirderConnection' ? insertingObjectInfo : null;
  return {
    carriedComponentDesignCandidates: getCarriedComponentDesignCandidatesForActiveComponentDesign(state),
    insertionInfo,
    carryingComponentDesign: getActiveComponentDesign(state),
  };
};

const actionCreators = {
  finishInsertingJackGirderConnection,
};

export default connect(mapStateToProps, actionCreators)(CarriedComponentConnectionInsertion);
